import NavigableModal from '@components/NavigableModal/NavigableModal';
import { useAppSelector } from '@redux/hooks';
import { Icon } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import { ModalHeader } from '@xo-union/tk-component-modals';
import delay from 'lodash/delay';
import React, { type FC, useRef } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import type { Decorated } from 'types/vendor';
import { ShareLink } from './components/share_link';

import Styles from './styles.scss';

interface Props {
	modalIsOpen: boolean;
	onClose: () => void;
}

export const ShareModal: FC<Props> = ({ modalIsOpen, onClose }) => {
	const vendor = useAppSelector((state) => state.vendor.vendor as Decorated);
	const { storefrontCard, uriData, name } = vendor;

	const linkCopiedRef = useRef<HTMLDivElement>(null);

	const showNotification = () => {
		if (linkCopiedRef.current) {
			ReactTooltip.show(linkCopiedRef.current);
			delay(ReactTooltip.hide, 2000, linkCopiedRef.current);
		}
	};

	return (
		<NavigableModal
			size="md"
			closeCallback={() => onClose()}
			isModalOpen={modalIsOpen}
		>
			<ModalHeader className={Styles.modalHeader}>
				Share this vendor
			</ModalHeader>
			<div className={Styles.shareLinksContainer}>
				<div className={Styles.shareLinkBox}>
					<ShareLink url={uriData.uri} text="Email" icon="mail" />
				</div>
				<div className={Styles.shareLinkBox}>
					<CopyToClipboard
						text={uriData.uri}
						onCopy={showNotification}
						data-testid="test-copy-to-clipboard"
					>
						<div className={Styles.shareLink}>
							<Icon
								name="link"
								size="md"
								className={Styles.shareLinkImage}
								aria-label="Copy link"
							/>
							<TextBody size="md">Copy link</TextBody>
						</div>
					</CopyToClipboard>
					<div ref={linkCopiedRef} data-tip="Link Copied!" />
					<ReactTooltip place="right" type="light" border delayShow={500} />
				</div>
				<div className={Styles.shareLinkBox}>
					<ShareLink url={uriData.uri} text="Facebook" icon="facebook-circle" />
				</div>
				<div className={Styles.shareLinkBox}>
					<ShareLink url={uriData.uri} text="X" name={name} icon="x-circle" />
				</div>
				<div className={Styles.shareLinkBox}>
					<ShareLink
						url={uriData.uri}
						image={storefrontCard.url}
						text="Pinterest"
						icon="pinterest-circle"
					/>
				</div>
			</div>
		</NavigableModal>
	);
};
